import { render, staticRenderFns } from "./UpdateLevelOrder.vue?vue&type=template&id=0baacbf7&scoped=true"
import script from "./UpdateLevelOrder.vue?vue&type=script&lang=js"
export * from "./UpdateLevelOrder.vue?vue&type=script&lang=js"
import style0 from "./UpdateLevelOrder.vue?vue&type=style&index=0&id=0baacbf7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0baacbf7",
  null
  
)

export default component.exports